import { forwardRef, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input, InputProps } from './Input';

export interface SecretInputProps extends Omit<
  InputProps,
  'type' | 'rightIcon'
> {
  showToggle?: boolean;
}

export const SecretInput = forwardRef<HTMLInputElement, SecretInputProps>(
  ({ showToggle = true, ...props }, ref) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
      <Input
        {...props}
        ref={ref}
        type={isVisible ? 'text' : 'password'}
        rightIcon={
          showToggle ? (
            <button
              type="button"
              onClick={() => setIsVisible((prev) => !prev)}
              className="focus:outline-hidden p-1 text-content-muted hover:text-content-main"
              title={isVisible ? 'Ocultar valor' : 'Mostrar valor'}
              aria-label={isVisible ? 'Ocultar valor' : 'Mostrar valor'}
              tabIndex={-1}
            >
              {isVisible ? (
                <EyeOff className="h-4 w-4" />
              ) : (
                <Eye className="h-4 w-4" />
              )}
            </button>
          ) : undefined
        }
      />
    );
  }
);

SecretInput.displayName = 'SecretInput';
